import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Actions } from "./Actions";
import classNames from "classnames";
import { ThemeProviderContext } from "../../ThemeProvider";
export const TextField = (props) => {
    const handleInputChange = (event) => {
        props.setKeywordFilter(event.target.value);
    };
    const handleInputKeyDown = (event) => {
        if (event.code === "Backspace" &&
            props.isClearable &&
            props.keywordFilter.length === 0) {
            props.clearValue();
        }
        if (["Enter", "Space"].includes(event.key) &&
            props.activeIndex !== null &&
            props.filteredOptions.length > 0) {
            props.onSelectionChange(props.flatten(props.filteredOptions)[props.activeIndex]);
        }
        if (event.key === "Escape") {
            props.closeListbox();
        }
    };
    return (_jsx(ThemeProviderContext.Consumer, { children: ({ translate }) => (_jsxs("div", { className: "relative flex", children: [_jsxs("span", { className: "flex-1 flex", children: [props.value && (_jsx("span", { className: classNames("text-ellipsis overflow-hidden whitespace-nowrap mr-1"), children: props.value.label })), _jsx("input", Object.assign({}, props.getReferenceProps({
                            ref: props.triggerRef,
                            type: "text",
                            value: props.keywordFilter,
                            onChange: handleInputChange,
                            onBlur: props.onBlur,
                            onKeyDown: handleInputKeyDown,
                            disabled: props.isDisabled,
                            readOnly: props.isReadonly,
                            autoComplete: "off",
                            placeholder: !props.value
                                ? props.placeholder || translate("select.type_to_search")
                                : "",
                            className: "outline-none bg-transparent placeholder-text-subdued flex-1 min-w-[40px] grow",
                            size: 1,
                            "aria-autocomplete": "list",
                            id: props.id,
                        })))] }), _jsx(Actions, Object.assign({}, props, { isEmptyValue: !props.value }))] })) }));
};
//# sourceMappingURL=TextField.js.map